// Nav entry of Pronunciation (shell/nav.ts collects every routes/*.nav.ts; `order` places it in the rail, the tabs and Lisää).
import { defineNav } from '../shell/nav-entry';

export const nav = defineNav({
  id: 'pronunciation',
  path: '/pronunciation',
  icon: 'pronunciation',
  group: 'practice',
  phone: 'more',
  order: 400,
  // Ääntämisvalmentaja's open-mic screens are study screens (no overscroll, no player bar): a sound's live rung,
  // the voice and free mode, the calibration
  session: ({ pathname }) => /^\/pronunciation\/valmentaja\/([^/]+\/live|aani|kalibrointi)\/?$/.test(pathname),
  load: () => import('./Pronunciation'),
});
